import { Fragment, useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import data from '../Nabi.json';
 
export default function Nabi() {
  const [open, setOpen] = useState(false);
 
  const handleOpen = () => setOpen(!open);
 
  return (
    <section className='bg-accent-secondary lg:h-[650px] pb-12'
        data-aos='fade-up'
        data-aos-offset='350'>
        <div className='container mx-auto h-full relative pt-20'>
        <h2 className='text-secondary flex item-center justify-center text-3xl mb-5'>Kumpulan Kisah 25 Nabi</h2>
        <div className="items-center content-center justify-center mb-5">
        {data.map((item, index) => (
            <Fragment>
            <Button onClick={handleOpen} variant="gradient" className="bg-secondary mr-5 mt-9">
                {item.name}
            </Button>
            <Dialog open={open} handler={handleOpen} className="mx-auto w-9/12 ">
                <DialogHeader className="ml-5 mb-5">{item.name}</DialogHeader>
                <img src={item.image_url}/>
                <DialogBody divider className="ml-5 mt-5">
                {item.description}
                </DialogBody>
                <DialogFooter>
                <Button
                    variant="text"
                    color="red"
                    onClick={handleOpen}
                    className="mr-1"
                >
                    <span>Cancel</span>
                </Button>
                </DialogFooter>
            </Dialog>
            </Fragment>
            ))}
            </div>
            </div>
    </section>
  );
}